const shipmentDetails = {
  'shipmentDetails.shipmentDetails': 'Shipment Details',
  'shipmentDetails.updateShipmentStatus': 'Update Shipment Status',
  'shipmentDetails.saveLogistics': 'Add Logistics',
  'shipmentDetails.updateLogistics': 'Update Logistics',

  'shipmentDetails.orderId': 'Order ID',
  'shipmentDetails.shipmentId': 'Shipment ID',
  'shipmentDetails.shipmentId.placeholder': 'Enter shipment ID',
  'shipmentDetails.shipmentMethod': 'Shipping Method',
  'shipmentDetails.shipmentDate': 'Shipping Date',
  'shipmentDetails.shipmentStatus': 'Shipping Status',
  'shipmentDetails.shipmentStatusName': 'Shipping Status',

  'shipmentDetails.recipientInfo': 'Recipient Information',
  'shipmentDetails.recipientName': 'Recipient Name',
  'shipmentDetails.phone': 'Contact Number',
  'shipmentDetails.postalCode': 'Postal Code',
  'shipmentDetails.email': 'Email',
  'shipmentDetails.address': 'Shipping Address',

  'shipmentDetails.logisticsList': 'Logistics List',
  'shipmentDetails.logisticsList.trackingNumber': 'Tracking Number',
  'shipmentDetails.logisticsList.trackingNumber.placeholder': 'Enter tracking number',
  'shipmentDetails.logisticsList.shipmentId': 'Shipment ID',
  'shipmentDetails.logisticsList.carrierName': 'Carrier Name',
  'shipmentDetails.logisticsList.carrierName.placeholder': 'Enter carrier name',
  'shipmentDetails.logisticsList.deliveryStatus': 'Delivery Status',
  'shipmentDetails.logisticsList.shipmentDate': 'Shipping Date',
  'shipmentDetails.logisticsList.shipmentDate.placeholder': 'Select shipping date',
  'shipmentDetails.logisticsList.estimatedArrival': 'Estimated Arrival Date',
  'shipmentDetails.logisticsList.estimatedArrival.placeholder': 'Select estimated arrival date',
  'shipmentDetails.logisticsList.actualArrival': 'Actual Arrival Date',
  'shipmentDetails.logisticsList.actualArrival.placeholder': 'Select actual arrival date',
  'shipmentDetails.logisticsList.shipper': 'Shipper',
  'shipmentDetails.logisticsList.shipper.placeholder': 'Enter shipper name',
  'shipmentDetails.logisticsList.contact': 'Contact Information',
  'shipmentDetails.logisticsList.contact.placeholder': 'Enter contact information',
  'shipmentDetails.logisticsList.trackingRecords': 'Tracking Records',
  'shipmentDetails.logisticsList.update': 'Update',

  'shipmentDetails.trackingRecords.trackingTime': 'Tracking Time',
  'shipmentDetails.trackingRecords.trackingLocation': 'Tracking Location',
  'shipmentDetails.trackingRecords.remark': 'Remark',
  'shipmentDetails.trackingRecords.attachment': 'Attachment',
  'shipmentDetails.trackingRecords.update': 'Update Tracking',
  'shipmentDetails.trackingRecords.location': 'Location',
  'shipmentDetails.trackingRecords.location.placeholder': 'Enter location',
  'shipmentDetails.trackingRecords.time': 'Time',
  'shipmentDetails.trackingRecords.time.placeholder': 'Select time',

  'shipmentDetails.productList': 'Shipped Products List',
};

export default shipmentDetails;
